import { JSX } from "react"
import {
  Stack, Typography, TypographyProps,
  useTheme
} from "@mui/material"

export type BlockCaptionProps = {
  caption: string
  rightElement?: JSX.Element
  sticky?: boolean
} & TypographyProps
export const BlockCaption = ({
  caption,
  rightElement,
  sticky,
  ...others
} : BlockCaptionProps) => {
  const theme = useTheme()
  return (
    <Stack
      paddingTop={sticky === false ? undefined : 1}
      paddingX={2}
      direction='row'
      alignItems='flex-end'
      justifyContent="flex-end"
      spacing={1}
      flexWrap="wrap"
      position={sticky === false ? undefined : "sticky"}
      top={sticky === false ? undefined : 0}
      zIndex={sticky === false ? undefined : 2}
      sx={{
        background: theme.palette.background.paper,
        borderBottom: 1,
        borderColor: theme.palette.divider
      }}
    >
      <Typography flexGrow={1} variant="subtitle2" component="div" whiteSpace="nowrap" {...others}>{caption}</Typography>
      {rightElement}
    </Stack>
  )
}
